export const ASSIGNMENT_MODIFICATIONS_TEXT = {
	TITLE: 'Assignment modifications',
	MODIFIED: 'Modified',
	BY: 'by',
	menuAriaLabel: 'Breakdown actions',
	viewBreakdownDetails: 'View breakdown details',
};
